window.MoleculeCompare = (function () {
  var DOUBLE_MARKER_TITLES = ['ENGAGE ELITE HYBRID 14″ MATTRESS', 'ENGAGE ELITE 14″ MATTRESS'];

  function applyFixes(products) {
    (products || []).forEach(function (product) {
      var mattress = product && product.metafields && product.metafields.mattress;
      if (!mattress) return;

      if (DOUBLE_MARKER_TITLES.indexOf(product.title) !== -1 && mattress.active_phase_change_cooling === '✅') {
        mattress.active_phase_change_cooling = '✅ ✅';
      }
    });

    return products;
  }

  function findProduct(products, id) {
    return (products || []).filter(function (product) {
      return String(product.id) === String(id);
    })[0];
  }

  function updateRows(container, product, index) {
    if (!container) return;

    var cells = container.querySelectorAll('.compare-rows .compare-row-meta-item[data-index="' + index + '"]');

    Array.prototype.forEach.call(cells, function (cell) {
      Array.prototype.forEach.call(cell.querySelectorAll('[data-meta]'), function (element) {
        var key = element.getAttribute('data-meta');

        if (key === 'price') {
          element.innerText = product.price_min || '';
          return;
        }

        var mattress = (product.metafields && product.metafields.mattress) || {};
        var value = mattress[key];

        element.innerText = value === undefined || value === null ? '❌' : value;
      });
    });
  }

  function updateColumn(container, product, index) {
    if (!container || !product) return;

    var column = container.querySelector('.compare-product[data-index="' + index + '"]');
    if (!column) return;

    var image = column.querySelector('.column-item__image img');
    var title = column.querySelector('.column-item__heading');
    var firmness = column.querySelector('.column-item__metafield span');
    var url = column.querySelector('.column-item__url');
    var priceMin = column.querySelector('.column-item__pricing .price-min');
    var priceCompare = column.querySelector('.column-item__pricing .price-compare-at');
    var select = column.querySelector('.js-column-item-select');

    if (select) {
      select.value = product.id;
      Array.prototype.forEach.call(select.options, function (option) {
        option.selected = String(option.value) === String(product.id);
      });
    }

    function paintText() {
      if (title) title.textContent = product.title;
      if (priceMin) priceMin.textContent = product.price_min;
      if (url) url.href = product.url;
      if (firmness) firmness.textContent = (product.metafields && product.metafields.mattress.firmness) || '';
      if (priceCompare) {
        priceCompare.textContent = product.on_sale ? product.compare_at_price_min : '';
        priceCompare.hidden = !product.on_sale;
      }
    }

    if (image && product.featured_image) {
      image.onload = paintText;
      image.src = product.featured_image;
      image.srcset = [
        product.featured_image + '&width=180 180w',
        product.featured_image + '&width=300 300w',
        product.featured_image + '&width=600 600w'
      ].join(', ');
      if (image.complete) paintText();
    } else {
      paintText();
    }

    updateRows(container, product, index);
    unfadeColumn(container, index);
  }

  function eachRowCell(container, index, callback) {
    var cells = container.querySelectorAll('.compare-rows .compare-row-meta-item[data-index="' + index + '"]');
    Array.prototype.forEach.call(cells, callback);
  }

  function fadeColumn(container, index) {
    var column = container.querySelector('.compare-product[data-index="' + index + '"]');
    if (column) column.classList.add('column-item--faded');

    eachRowCell(container, index, function (cell) {
      cell.classList.add('faded');
    });
  }

  function unfadeColumn(container, index) {
    var column = container.querySelector('.compare-product[data-index="' + index + '"]');
    if (column) column.classList.remove('column-item--faded');

    eachRowCell(container, index, function (cell) {
      cell.classList.remove('faded');
    });
  }

  function toggleColumn(container, index, visible) {
    var column = container.querySelector('.compare-product[data-index="' + index + '"]');
    if (column) column.hidden = !visible;

    eachRowCell(container, index, function (cell) {
      cell.hidden = !visible;
    });
  }

  return {
    applyFixes: applyFixes,
    findProduct: findProduct,
    updateRows: updateRows,
    updateColumn: updateColumn,
    fadeColumn: fadeColumn,
    unfadeColumn: unfadeColumn,
    toggleColumn: toggleColumn
  };
})();
